import React, {useState} from 'react';
import {Link} from "react-router-dom";
import {OrganizationData, WebSiteData} from '../../components/structuredData.js'

import {MainPageResult} from '../../../../server/routes/main.js'

interface MainProps {
    server: string;
    pageData: unknown;
}

interface ComponentProps {
    props: MainPageResult;
}

export default function Main({server, pageData}: MainProps) {

    const typedPageData = pageData as MainPageResult;
	let [data, setData] = useState(typedPageData);

	return (
        <>
            <OrganizationData />
            <WebSiteData />
            
            <MainHeader props={data}/>
            <TargetedSalesLeads/>
            <WebsiteDetailedInfo/>
            <MarketAnalytics/>
        </>
    )
}

function MainHeader({props}: ComponentProps) {

    return (

        <section className="section section-lg">
            <div className="container">
                <div className="row row-50 ">
                    <div className="col-sm-12 col-md-12 col-lg-12 ">
                    <div className="text-right">
                        <h3 style={{color:'darkblue'}}>
                            Accurate web technology detection
                        </h3>
                        <h4 style={{color:'darkblue'}}>
                            <b>
                                Detected 
                                <Link 
                                    to="/technology-type" 
                                    title="Popular Web Technologies" 
                                    className="link-hover"
                                >
                                    {' '}{props.TechnologyCount}{' '}
                                </Link> 
                                technologies
                                in 
                                <Link
                                    to="/technology-type" 
                                    title="Web Technology Categories" 
                                    className="link-hover"
                                >
                                    {' '}{props.CategoryCount}{' '}
                                </Link> 
                                categories, and  
                                <Link 
                                    to="/advertisers" 
                                    title="ads.txt Advertisers" 
                                    className="link-hover"
                                >
                                    {' '}{props.AdvertisersCount}{' '}
                                </Link> 
                                avertisers on 120+ million top sites.
                            </b>
                        </h4>
                        </div>    
                    </div>    
                </div>
            </div>
            <div className="container">                
                <div className="row row-50 ">
                    <div className="col-sm-12 col-md-12 col-lg-12 ">
                        <h2>Lookup website or technology</h2>
                        Discover what technologies a website is built on or find out what websites use a particular{' '} 
                        <Link
                            to="/technology-type"
                            className="link-hover" 
                            title="Popular Web Technologies" 
                        >
                            web technology
                        </Link>
                        <br/>
                        <br/>
                    </div>
                </div>   
                {/**          
                <div className="row row-50 ">
                    <form className="rd-form rd-search form-inline" action="search" method="GET">
                        <div className="form-wrap">
                            <label className="form-label" htmlFor="rd-search-form-input">Lookup website or technology</label> 
                                <input className="form-input" id="rd-search-form-input" type="text" name="q" autoComplete="off" required /> 
                        </div>
                        <div className="form-wrap form-button">
                            <button className="button button-secondary button-shadow" type="submit">Search</button>
                        </div>
                    </form>
                </div> */}   
                <div>			
                    <form className="rd-form rd-search form-inline" action="search" method="GET">
                        <div className="form-wrap">
                            <input required type="text" className="form-input"
                             title="Type the technology or domain name without any special characters or quotation marks" 
                             placeholder="Lookup website or web technology (for example Magento or Shopify)"
                             pattern="[\-a-zA-Z0-9\s\/\.\(\):_&@\?=]+"
                              name="q"/>
                        </div>
                        <div className="form-wrap form-button">
                            <button className="button button-secondary button-shadow" type="submit">Search</button>
                        </div>
                    </form>
                </div> 
            </div>
        </section>
    )
}

function TargetedSalesLeads() {

    return (

        <section className="section section-md bg-gray-100">
            <div className="container">
                <div className="row row-50 ">
                    <div className="col-sm-12 col-md-6 col-lg-6 ">
                        <picture>
                            <source media="(min-width: 1400px)" srcSet="/s/wts-images/sample-report.png"/>
                            <source media="(min-width: 700px)" srcSet="/s/wts-images/sample-report-sm.png"/>
                            <source media="(min-width: 300px)" srcSet="/s/wts-images/sample-report-sm.png"/>
                            <img width="1400" height="800"
                                src="/s/wts-images/sample-report.png" 
                                title="Sample technology report" 
                                style={{width:'auto'}}
                            />
                        </picture>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 ">
                        <div className="container">
                            <h3>Download targeted sales leads list</h3>

                            <p className="text-gray-900">
                                Find sales opportunities. Compile and download a list of websites that use a specific technology. You can further narrow down your search by website language, domain, country, and many other criteria. When available, reports include contact information (addresses, phones, emails) and social media links.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

function WebsiteDetailedInfo() {

    return (<>
    
        <section className="section section-md">
            <div className="container">
                <div className="row row-50">
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="container">
                            <h3>Detailed website information</h3>

                            <p className="text-gray-900">
                                Find the website's detailed information: technology composition, contact information of key people, language, country and many more. 
                                Look up websites that use similar or competing technologies.
                            </p>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <div 
                            className="owl-carousel owl-carousel_type-2 wow fadeIn" 
                            data-items="1" 
                            data-dots="true" 
                            data-nav="true" 
                            data-stage-padding="0"
                            data-loop="true" 
                            data-margin="30" 
                            data-mouse-drag="false" 
                            data-autoplay="true"
                            data-autoplay-timeout="4000"
                            data-wow-delay="0.3s"
                        >
                            <blockquote className="quote-classic">
                                <picture>
                                    <source media="(min-width: 800px)" srcSet="/s/wts-images/site-technology-2.png"/>
                                    <source media="(min-width: 400px)" srcSet="/s/wts-images/site-technology-2-sm.png"/>
                                    <source media="(min-width: 200px)" srcSet="/s/wts-images/site-technology-2-sm.png"/>
                                    <img width="800" height="600" 
                                        src="/s/wts-images/site-technology-2.png" 
                                        title="Website information and statistics" 
                                        style={{width:'auto'}}
                                    />
                                </picture>
                            </blockquote>
                            <blockquote className="quote-classic">
                                <picture>
                                    <source media="(min-width: 800px)" srcSet="/s/wts-images/site-technology-3.png"/>
                                    <source media="(min-width: 400px)" srcSet="/s/wts-images/site-technology-3-sm.png"/>
                                    <source media="(min-width: 200px)" srcSet="/s/wts-images/site-technology-3-sm.png"/>
                                    <img  width="800" height="600" 
                                        src="/s/wts-images/site-technology-3.png" 
                                        title="Website technology stack" 
                                        style={{width:'auto'}}
                                    />
                                </picture>
                            </blockquote>
                            <blockquote className="quote-classic">
                                <picture>
                                    <source media="(min-width: 800px)" srcSet="/s/wts-images/site-technology-1.png"/>
                                    <source media="(min-width: 400px)" srcSet="/s/wts-images/site-technology-1-sm.png"/>
                                    <source media="(min-width: 200px)" srcSet="/s/wts-images/site-technology-1-sm.png"/>
                                    <img width="800" height="600" 
                                        src="/s/wts-images/site-technology-1.png" 
                                        title="Contact information and social media links" 
                                        style={{width:'auto'}}
                                    />
                                </picture>
                            </blockquote>
                            <blockquote className="quote-classic">
                                <picture>
                                    <source media="(min-width: 800px)" srcSet="/s/wts-images/site-technology-4.png"/>
                                    <source media="(min-width: 400px)" srcSet="/s/wts-images/site-technology-4-sm.png"/>
                                    <source media="(min-width: 200px)" srcSet="/s/wts-images/site-technology-4-sm.png"/>
                                    <img width="800" height="600" 
                                        src="/s/wts-images/site-technology-4.png" 
                                        title="Discovered website subdomains" 
                                        style={{width:'auto'}}
                                    />
                                </picture>
                            </blockquote>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </>)
}


function MarketAnalytics() {
    
    return (

        <section className="section section-md bg-gray-100">
            <div className="container">
                <div className="row row-50 ">
                    <div className="col-sm-12 col-md-6 col-lg-6 order-2 order-md-1">
                        <div 
                            className="owl-carousel owl-carousel_type-2 wow fadeIn" 
                            data-items="1" 
                            data-dots="true" 
                            data-nav="true" 
                            data-stage-padding="0"
                            data-loop="true" 
                            data-margin="30" 
                            data-mouse-drag="false" 
                            data-autoplay="true" 
                            data-autoplay-timeout="4000" 
                            data-wow-delay="0.3s"
                        >
                            <blockquote className="quote-classic">
                                <picture>
                                    <source media="(min-width: 800px)" srcSet="/s/wts-images/market-share.png"/>
                                    <source media="(min-width: 400px)" srcSet="/s/wts-images/market-share-sm.png"/>
                                    <source media="(min-width: 200px)" srcSet="/s/wts-images/market-share-sm.png"/>
                                    <img 
                                        src="/s/wts-images/market-share.png"  
                                        title="Technology market share" 
                                        style={{width:'auto'}}
                                    />
                                </picture>
                            </blockquote>
                            <blockquote className="quote-classic">
                                <picture>
                                    <source media="(min-width: 800px)" srcSet="/s/wts-images/market-share-1.png"/>
                                    <source media="(min-width: 400px)" srcSet="/s/wts-images/market-share-1-sm.png"/>
                                    <source media="(min-width: 200px)" srcSet="/s/wts-images/market-share-1-sm.png"/>
                                    <img 
                                        src="/s/wts-images/market-share-1.png" 
                                        title="Historic market share trend" 
                                        style={{width:'auto'}}
                                    />
                                </picture>
                            </blockquote>
                        </div>

                    </div>
                        <div className="col-sm-12 col-md-6 col-lg-6 order-1 order-md-2">
                            <div className="container">			
                                <h3>Web technology market share and trends</h3>

                                <p className="text-gray-900">
                                    Research web technology landscape. 
                                    Find out which technologies are on a rise and which are declining in popularity. 
                                    Discover how a particular technology stacks up against its competition. 
                                    Access market share analysis within a category and observe how it changes over time. 
                                    Identify sites that recently adopted the technology and sites that stopped using it.
                                </p>
                            </div>
                        </div>

                    </div>
            </div>
        </section>  
    )
}